/**
 * Build version helpers — exposed by Vite `define`:
 *   __BUILD_VERSION__  — base36 timestamp set at build time
 *   __BUILD_TIME__     — ISO timestamp set at build time
 *
 * Used by the BuildBadge UI and the console banner so anyone can confirm
 * "am I looking at the bundle I just published?".
 */

declare const __BUILD_VERSION__: string;

declare const __BUILD_TIME__: string;

export const BUILD_VERSION: string =
  typeof __BUILD_VERSION__ !== "undefined" ? __BUILD_VERSION__ : "dev";

export const BUILD_TIME: string =
  typeof __BUILD_TIME__ !== "undefined" ? __BUILD_TIME__ : "dev";

export function logBuildBanner(): void {
  console.info(
    `%c CashbackBR %c build ${BUILD_VERSION} %c ${BUILD_TIME}`,
    "background:#10B981;color:#fff;font-weight:700;padding:2px 6px;border-radius:3px 0 0 3px",
    "background:#0F172A;color:#FCD34D;padding:2px 6px;font-family:monospace",
    "background:#F8FAFC;color:#0F172A;padding:2px 6px;border-radius:0 3px 3px 0",
  );
}
